// import 'rxjs/add/operator/catch';
// import 'rxjs/add/operator/map';
import { Injectable } from '@angular/core';
import { ApplicationHttpClient } from 'app/application-http-client';
import { Observable } from 'rxjs';

import { Pushtodms } from '../home/pushtodms';
import { environment } from './../../../../environments/environment';


// import {Observable} from 'rxjs/Rx';
@Injectable()
export class PushtodmsService {
  private apiUrl = '/push/dms';

  public getPushToDmsInfo(customerId: string, eventId: string): Observable<Pushtodms> {
    const params = ApplicationHttpClient.toHttpParams({
      customerId: customerId,
      eventId: eventId
    });

    return this.http.get(this.apiUrl + '/GetPushToDMSForV4', { params: params, errorNotification: true });
  }

  public updatePushToDmsInfo(params: Object): Observable<Pushtodms> {
    return this.http.post(this.apiUrl + '/PushToDmsForV4', params);
  }

  public resubmitPushToDmsInfo(params: Object): Observable<string> {
    return this.http.put(this.apiUrl + '/ResubmitDealerPushV4', params);
  }

  constructor(private http: ApplicationHttpClient) {}
}
